import PropertyDetailsController from './property.details.controller.js';

class PropertyIntegrationController extends PropertyDetailsController {

    testIntegration () {
        this.saving = true;
        return this.integrationApiService.testIntegration(this.property.id)
            .then(() => {
                this.messageService.success(`Your Core Integration is working as expected!`);
                this.messageService.push();
                this.messageService.autoClear();
            })
            .catch(() => {
                this.messageService.failure(`An issue has occurred with your Core Integration, please contact Journey.`);
                this.messageService.push();
                this.messageService.autoClear();
            })
            .then(() => {
                this.saving = false;
            });
    }

    getVersion () {
        this.saving = true;
        return this.integrationApiService.getVersion(this.property.id)
            .then(response => {
                this.messageService.success(`Your Core Integration is on version ${response}!`);
                this.messageService.push();
            })
            .catch(() => {
                this.messageService.failure(`An issue has occurred with your Core Integration, please contact Journey.`);
                this.messageService.push();
                this.messageService.autoClear();
            })
            .then(() => {
                this.saving = false;
            });
    }

    runImport () {
        this.saving = false;
        return this.integrationApiService.getVersion(this.property.id)
            .then(() => {
                return this.integrationApiService.integrationImport(this.property.id)
                    .then(() => {
                        this.details.import_run = 1;
                        this.messageService.success(`The Core import has been queued!`);
                        this.messageService.push();
                    })
                    .catch(() => {
                        this.messageService.failure(`The import has run into an issue, please check with the RevSpa team.`);
                        this.messageService.push();
                    })
                    .then(() => {
                        this.saving = false;
                    });
            })
    }
}

export default PropertyIntegrationController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/controllers/property.integration.form.controller.js